import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowUp } from "lucide-react";
import React from "react";

const SalesOverview: React.FC = () => {
    return (
        <div className="flex flex-row items-center justify-start gap-x-4 h-[150px]">
            <Card className="w-full min-w-1/3 rounded-[8px] h-full flex">
                <CardContent className="flex flex-col items-start justify-center px-4">
                    <CardHeader className="w-full py-2 px-0">
                        <CardTitle className="text-sm font-medium">Weekly Revenue</CardTitle>
                    </CardHeader>
                    <span className="text-2xl font-medium">AED 57,000</span>
                    <div className="flex flex-row items-center justify-start gap-x-2">
                        <ArrowUp className="text-green-500" />
                        <span className="text-sm text-gray-400 font-medium">8.5% from last week</span>
                    </div>
                </CardContent>
            </Card>
            <Card className="w-full min-w-1/3 rounded-[8px] h-full flex">
                <CardContent className="flex flex-col items-start justify-center px-4">
                    <CardHeader className="w-full py-2 px-0">
                        <CardTitle className="text-sm font-medium">Total Sales</CardTitle>
                    </CardHeader>
                    <span className="text-2xl font-medium">378</span>
                    <span className="text-sm text-gray-400 font-medium">This week</span>
                </CardContent>
            </Card>
            <Card className="w-full min-w-1/3 rounded-[8px] h-full flex">
                <CardContent className="flex flex-col items-start justify-center px-4">
                    <CardHeader className="w-full py-2 px-0">
                        <CardTitle className="text-sm font-medium">Average Order Value</CardTitle>
                    </CardHeader>
                    <span className="text-2xl font-medium">AED 476</span>
                </CardContent>
            </Card>
        </div>
    );
}

export default SalesOverview;